import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable({ providedIn: "root" })
export class UpcomingService {
  private http = inject(HttpClient);

  getUpcomingMarkets(sportId: string, date: string): Observable<any> {
    const url = `${environment.mURL}/bf/event-type-markets/${sportId}`;
    const params = {
      maxResults: "75",
      date,
      sortBy: "date",
      locale: "en",
    };
    return this.http.get(url, { params });
  }
}
